
import React, { createContext, useContext } from "react";

// This allows us to pass the dashboard date filter to all metric/chart components
type DashboardRange = "month" | "year";
const DashboardContext = createContext<{ range: DashboardRange }>({ range: "month" });

export function DashboardProvider({ range, children }: { range: DashboardRange; children: React.ReactNode }) {
  return (
    <DashboardContext.Provider value={{ range }}>{children}</DashboardContext.Provider>
  );
}

export function useDashboardRange() {
  return useContext(DashboardContext).range;
}
